import { GlobalContext } from "contexts/GlobalContext";
import { Fragment, ReactNode, useContext } from "react";
import { ModalConfirmButton } from "components/buttons/ModalConfirmButton";

export const KickPlayerButton = (props: {
    className: string;
    playerName: string;
    playerId: number;
    code: string;
    btnText: ReactNode;
}) => {
    const { className, playerId, code, playerName, btnText } = props;

    const { moderateService, setWindowConfirm, catchServerError, addNotification } = useContext(GlobalContext);
    const { banPlayer } = moderateService;

    return (
        <ModalConfirmButton
            btnText={btnText}
            className={className}
            confirmText="Kick"
            confirmIcon="fas fa-ban"
            description={
                <Fragment>
                    Are you sure you want to kick <strong>{playerName}</strong>?
                </Fragment>
            }
            onConfirm={() => {
                setWindowConfirm(old => old && { ...old, loading: true });

                banPlayer({
                    code: code,
                    playerIdToBan: playerId,
                })
                    .then(x => {
                        if (x.success) {
                            setWindowConfirm(old => old && { ...old, successMessage: "Player kicked" });
                        } else {
                            addNotification({
                                title: "Unable to ban player",
                                type: "failure",
                            });
                        }
                    })
                    .catch(catchServerError);
            }}
        />
    );
};
